import script from "./SplitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitsView.vue?vue&type=script&setup=true&lang=js"

import "./SplitsView.vue?vue&type=style&index=0&id=6309a90a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6309a90a"]])

export default __exports__